import Styles from "./modal.module.css";
import { useState } from "react";
import { Button, Modal } from "antd"; // Import Modal and Button from Ant Design
import { useForm, SubmitHandler } from "react-hook-form";
import { ModalType, DateModal } from "../Types";
import moment from "moment";
import React, { useEffect } from "react";

const Address: React.FC<ModalType> = ({
    isModalVisible,
    details,
    updateData,
    ModalLoad,
    setisModalVisible,
    status,
}) => {
    const handleOk = () => {
        setisModalVisible(false);

        reset({ video_url: "", draw_date: "" });
    };
    const handleCancel = () => {
        setisModalVisible(false);

        reset({ video_url: "", draw_date: "" });
    };
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm<DateModal>();
    useEffect(() => {
        if (status != 1) {
            reset({
                draw_date: moment(details?.draw_date).format("YYYY-MM-DD"),
                video_url: details?.video_url,
            });
        } else {
            reset({ video_url: "", draw_date: "" });
        }
    }, [isModalVisible]);
    const onSubmit: SubmitHandler<DateModal> = (data) => {
        let formData: any = {
            ...data,
        };
        /*    if (status != 1) {
            delete formData.draw_date;
        } */
        updateData({ ...formData, campaign_id: details?.campaign_id });
    };

    return (
        <>
            <Modal
                // title="Custom Modal"
                open={isModalVisible}
                onOk={handleOk}
                footer={null}
                onCancel={handleCancel}
                style={{ width: "80vw" }}
                className={Styles["custom_modal_navbar"]}>
                <div className={Styles["adress_form"]}>
                    <div className={Styles["form"]}>
                        <h3 style={{ textAlign: "center" }}>
                            Annoucement Date
                        </h3>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className={Styles["Form-control"]}>
                                <label>
                                    Draw Date <span>*</span>
                                </label>
                                <input
                                    type="date"
                                    {...register("draw_date", {
                                        required: "This field is required",
                                    })}
                                    // disabled={status != 1}
                                />
                                {errors?.draw_date && (
                                    <p>{errors?.draw_date?.message}</p>
                                )}
                            </div>
                            <div className={Styles["Form-control"]}>
                                <label>
                                    Video URL <span>*</span>
                                </label>
                                <input
                                    {...register("video_url", {
                                        required: "This field is required",
                                    })}
                                />
                                {errors?.video_url && (
                                    <p>{errors?.video_url?.message}</p>
                                )}
                            </div>
                            {status == 1 && (
                                <p style={{ color: "red" }}>
                                    <b>Note:</b>{" "}
                                    <span>
                                        Please Select Draw Date before
                                        Announcing Winner
                                    </span>
                                </p>
                            )}
                            <Button
                                loading={ModalLoad}
                                onClick={handleSubmit(onSubmit)}>
                                Submit
                            </Button>
                        </form>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default Address;
